import { Editor } from '@tiptap/react';
import { useEffect, useState } from 'react';
import useTextEditor from './useTextEditor';

interface UseOperationsOnSelectionChangeProps {
  editor: Editor | null;
  shouldDoOperation: boolean;
  onSelectionChanged: (selectedHtml: string) => void;
}

const useOperationsOnSelectionChange = ({
  editor,
  shouldDoOperation,
  onSelectionChanged,
}: UseOperationsOnSelectionChangeProps) => {
  const [previousSelection, setPreviousSelection] = useState(editor?.state.selection);
  const { getEditorSelectedState } = useTextEditor(editor);

  useEffect(() => {
    if (!editor) return;

    const handleSelectionUpdate = () => {
      if (shouldDoOperation) {
        return;
      }

      const currentSelection = editor.state.selection;
      const { selectedHtml } = getEditorSelectedState();

      // Reset fonts if selection has changed
      if (
        currentSelection.from !== previousSelection?.from ||
        currentSelection.to !== previousSelection?.to
      ) {
        onSelectionChanged(selectedHtml);
      }

      // Update the previous selection state
      setPreviousSelection(currentSelection);
    };

    // Listen for selection updates
    editor.on('selectionUpdate', handleSelectionUpdate);

    // Cleanup listener on unmount
    return () => {
      editor.off('selectionUpdate', handleSelectionUpdate);
    };
  }, [
    editor,
    getEditorSelectedState,
    onSelectionChanged,
    previousSelection,
    shouldDoOperation,
  ]);
};

export default useOperationsOnSelectionChange;
